// Modül 5 - Ünite 3, 4, 5, 6, 7 İçerikleri
// Gerçek Mülakat Soruları - Motivasyon, Durum, Kişisel, Takım, Final

const cabinCrewContentsM5U3to7 = {
  // ==================== ÜNİTE 3: MOTİVASYON SORULARI ====================
  'CM-M5-U3-L1': {
    lesson_id: 'CM-M5-U3-L1',
    title: 'Neden Kabin Memuru?',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Motivasyon Sorusuna Hazırlık',
      paragraphs: [
        'Bu soru HER mülakatta sorulur. Klişe cevaplar sizi eler.',
        'YANLIŞ cevaplar: "Dünyayı gezmek istiyorum", "Uçakları seviyorum", "Arkadaşım önerdi".',
        'DOĞRU yaklaşım: Güvenlik bilinci + hizmet tutkusu + kişisel motivasyon kombinasyonu.',
        'Örnek: "Kabin memurluğu benim için güvenlik sorumluluğu ve misafirperverliğin buluştuğu nokta. İnsanlara hizmet etmeyi, farklı kültürlerle çalışmayı ve dinamik bir ortamda olmayı seviyorum."',
        'Kişiselleştirin: Size özel bir deneyim veya hikaye ekleyin. "Bir seyahatimde kabin ekibinin yaklaşımı beni etkilemişti..." gibi.'
      ],
      keyPoints: [
        'Klişelerden kaçının',
        'Güvenlik + hizmet vurgulayın',
        'Kişisel hikaye ekleyin',
        'Tutku ve farkındalık gösterin'
      ]
    }
  },

  'CM-M5-U3-L2': {
    lesson_id: 'CM-M5-U3-L2',
    title: 'Neden Bu Havayolu?',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Şirkete Özel Motivasyon',
      paragraphs: [
        'Bu soru araştırma yapıp yapmadığınızı test eder.',
        'YANLIŞ: "Büyük bir şirket", "İyi maaş veriyor", "Herkes başvuruyor".',
        'DOĞRU: Şirkete özel, somut detaylar verin.',
        'THY örneği: "5 kıtada 350+ destinasyon, Türk misafirperverliği, sürekli büyüyen filo ve yeni açılan rotalar beni heyecanlandırıyor."',
        'Emirates örneği: "Dubai merkezli global marka, çok kültürlü ekip yapısı ve premium servis anlayışı kariyer hedeflerimle örtüşüyor."',
        'Araştırma: Şirket web sitesi, haberler, LinkedIn, çalışan yorumları okuyun.'
      ],
      keyPoints: [
        'Şirkete özel detaylar verin',
        'Araştırma yaptığınızı gösterin',
        'Değerlerinizi şirketle eşleştirin',
        'Güncel haberlerden bahsedin'
      ]
    }
  },

  'CM-M5-U3-L3': {
    lesson_id: 'CM-M5-U3-L3',
    title: 'Senaryo: Motivasyon Testi',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Mülakatçı soruyor: "Neden kabin memuru olmak istiyorsunuz?"',
      question: 'En iyi cevabı seçin:',
      options: [
        { id: 'A', text: 'Dünyayı gezmek ve farklı kültürleri tanımak istiyorum.', isCorrect: false },
        { id: 'B', text: 'Güvenlik sorumluluğu taşımak, insanlara en iyi hizmeti sunmak ve dinamik bir ortamda çalışmak bana enerji veriyor. Geçen yıl bir uçuşta yaşadığım deneyim bu mesleğe olan tutkumu pekiştirdi.', isCorrect: true },
        { id: 'C', text: 'Kabin memurluğu şık bir meslek ve iyi para kazandırıyor.', isCorrect: false },
        { id: 'D', text: 'Başka iş bulamadım, bu sektör giriş seviyesi iş sunuyor.', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Güvenlik bilinci, hizmet tutkusu ve kişisel hikaye kombinasyonu. Bu profesyonel ve samimi.',
        wrong: 'Bu cevap ya yüzeysel ya da ilgisiz. Güvenlik + hizmet + kişisel motivasyon kombinasyonu gerekli.'
      },
      explanation: 'Motivasyon sorusu filtreleme aracıdır. Havayolları sadece "gezmek isteyen" değil, mesleğin sorumluluğunu anlayan adaylar ister.'
    }
  },

  'CM-M5-U3-L4': {
    lesson_id: 'CM-M5-U3-L4',
    title: '🎮 Sürükle-Bırak: Doğru Cevap',
    type: 'dragdrop',
    duration: 4,
    xp: 35,
    dragdrop: {
      instruction: 'Motivasyon cevabının unsurlarını önem sırasına göre sıralayın',
      items: [
        { text: '🛡️ Güvenlik bilinci ve sorumluluk', order: 1 },
        { text: '🤝 Hizmet tutkusu ve misafirperverlik', order: 2 },
        { text: '🌍 Çok kültürlü ortamda çalışma', order: 3 },
        { text: '📖 Kişisel hikaye veya deneyim', order: 4 },
        { text: '✈️ Dünyayı gezme isteği', order: 5 }
      ]
    }
  },

  // ==================== ÜNİTE 4: DURUM SORULARI ====================
  'CM-M5-U4-L1': {
    lesson_id: 'CM-M5-U4-L1',
    title: 'Zor Yolcu Türleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Zor Yolcu Senaryolarına Hazırlık',
      paragraphs: [
        'Mülakatçılar "zor yolcu" senaryolarıyla stres altında tepkinizi test eder.',
        'Sarhoş yolcu: Sakin kalın, güvenlik riski değerlendirin, gerekirse kaptan\'a bilgi verin.',
        'Sinirli yolcu: Empati gösterin, dinleyin, çözüm odaklı yaklaşın.',
        'Talepkar yolcu: Profesyonel kalın, ne yapabileceğinizi açıklayın.',
        'Kural ihlali yapan: Güvenlik protokollerini nazik ama kararlı şekilde uygulayın.',
        'Altın formül: Dinle → Empati kur → Çözüm sun → Takip et'
      ],
      keyPoints: [
        'Her zaman sakin ve profesyonel',
        'Empati göster ama kuralları uygula',
        'Güvenlik her zaman öncelik',
        'Dinle → Empati → Çözüm → Takip'
      ]
    }
  },

  'CM-M5-U4-L2': {
    lesson_id: 'CM-M5-U4-L2',
    title: 'Tıbbi Acil Durumlar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Uçakta Sağlık Acilleri',
      paragraphs: [
        'Tıbbi aciller mülakatta sıkça sorulan konulardandır.',
        'İlk adım: Panik yapmayın, durum değerlendirmesi yapın.',
        'Ekip koordinasyonu: Purser\'a haber verin, diğer ekip üyelerinden destek alın.',
        'Yolcu yardımı: "Uçakta doktor var mı?" anonsu, ilk yardım kiti kullanımı.',
        'Pilot bildirimi: Ciddi durumlarda kaptan acil iniş kararı verebilir.',
        'Dokümantasyon: Her müdahale kayıt altına alınır.'
      ],
      keyPoints: [
        'Sakin kal, değerlendirme yap',
        'Ekiple koordineli çalış',
        'Kaptan\'a zamanında bilgi ver',
        'Her şeyi belgele'
      ]
    }
  },

  'CM-M5-U4-L3': {
    lesson_id: 'CM-M5-U4-L3',
    title: 'Senaryo: Türbülans Krizi',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      context: 'Uçuş sırasında ani şiddetli türbülans başladı. Yemek servisi devam ediyordu.',
      question: 'İlk tepkiniz ne olur?',
      options: [
        { id: 'A', text: 'Servis arabasını bırakır, hemen kendi koltuğuma koşarım.', isCorrect: false },
        { id: 'B', text: 'Servis arabasını güvenli şekilde kilitler, yolculara "emniyet kemerinizi bağlayın" uyarısı yapar, en yakın boş koltuğa otururum.', isCorrect: true },
        { id: 'C', text: 'Türbülans geçene kadar servise devam ederim.', isCorrect: false },
        { id: 'D', text: 'Panikleyerek bağırırım: "Düşüyoruz!"', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Önce ekipmanı güvenle sabitleme, sonra yolcuları uyarma, sonra kendinizi koruma. Profesyonel prosedür.',
        wrong: 'Bu tepki ya bencil (önce ben) ya da tehlikeli (devam etmek). Prosedür: Ekipman → Yolcular → Kendiniz.'
      },
      explanation: 'Türbülans prosedürü: 1) Tehlikeli ekipmanı sabitle, 2) Yolculara anons/uyarı, 3) Kendinizi koruyun. Güvenlik önce başkalarına, sonra size.'
    }
  },

  'CM-M5-U4-L4': {
    lesson_id: 'CM-M5-U4-L4',
    title: '🎮 Acil Durum Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { left: 'Sarhoş yolcu', right: 'Sakin kal, kaptan\'a bildir' },
        { left: 'Tıbbi acil', right: 'Ekip koordinasyonu, doktor anonsu' },
        { left: 'Türbülans', right: 'Ekipmanı sabitle, yolcuları uyar' },
        { left: 'Sinirli yolcu', right: 'Empati göster, çözüm sun' },
        { left: 'Kural ihlali', right: 'Nazik ama kararlı ol' },
        { left: 'Talepkar yolcu', right: 'Ne yapılabilir açıkla' }
      ]
    }
  },

  // ==================== ÜNİTE 5: KİŞİSEL SORULAR ====================
  'CM-M5-U5-L1': {
    lesson_id: 'CM-M5-U5-L1',
    title: 'Güçlü ve Zayıf Yönler',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Klasik Güç-Zayıflık Sorusunu Cevaplama',
      paragraphs: [
        'Bu soru öz-farkındalığınızı test eder. Hem dürüst hem stratejik olun.',
        'Güçlü yönler: İşle ilgili, somut örneklerle destekleyin. "İletişimim güçlü" yerine "Zor müşterilerle çalışırken sakin kalabiliyorum, geçen ay bir müşteri şikayetini çözdüğümde..."',
        'Zayıf yönler: ASLA kritik bir zayıflık söylemeyin. Geliştirdiğiniz bir alan seçin.',
        'Zayıflık formülü: Gerçek ama kritik olmayan zayıflık + Farkındalık + Geliştirme aksiyonu',
        'Örnek: "Bazen detaylara fazla takılabilirim. Bunun farkındayım ve büyük resmi kaçırmamak için kendime zaman sınırları koyuyorum."'
      ],
      keyPoints: [
        'Güçlü yönleri örnekle destekle',
        'Kritik zayıflık söyleme',
        'Zayıflık + farkındalık + aksiyon',
        'Gelişim odaklı cevap ver'
      ]
    }
  },

  'CM-M5-U5-L2': {
    lesson_id: 'CM-M5-U5-L2',
    title: '5 Yıl Sonra Nerede?',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kariyer Hedefi Sorusuna Cevap',
      paragraphs: [
        'Bu soru sadakat ve kariyer planınızı test eder.',
        'YANLIŞ: "5 yıl sonra burada olmayı planlamıyorum" veya "CEO olmak istiyorum".',
        'DOĞRU: Havayolunda kalma niyeti + gerçekçi ilerleme hedefi.',
        'Örnek: "5 yıl içinde deneyimli bir kabin memuru olarak şirketinize değer katmayı, belki de purser pozisyonuna ilerlemeyi hedefliyorum."',
        'Bonus: "Ayrıca eğitim veya yeni rotalarda görev almak gibi fırsatları değerlendirmek isterim."',
        'Mesaj: "Bu şirkette uzun vadeli kariyer planlıyorum."'
      ],
      keyPoints: [
        'Şirkette kalma niyeti göster',
        'Gerçekçi hedefler koy',
        'Gelişim ve ilerleme odaklı ol',
        'Şirkete bağlılık vurgula'
      ]
    }
  },

  'CM-M5-U5-L3': {
    lesson_id: 'CM-M5-U5-L3',
    title: 'Senaryo: Provokasyon Sorusu',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Mülakatçı provokatif bir soru soruyor:',
      question: '"Kabin memurluğu sadece garsonluk değil mi? Neden bu kadar önemsiyorsunuz?"',
      options: [
        { id: 'A', text: 'Haklısınız aslında, ama ben yine de istiyorum.', isCorrect: false },
        { id: 'B', text: 'Hayır! Bu çok yanlış bir görüş, bence çok saygısız.', isCorrect: false },
        { id: 'C', text: 'Anlıyorum bu algı var. Ancak kabin memurları öncelikle güvenlik personeli. Servis ikincil görev. Acil durumlarda hayat kurtaran, yolcu güvenliğinden sorumlu profesyonelleriz.', isCorrect: true },
        { id: 'D', text: 'Garsonluk da saygın bir meslek, ne var bunda?', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Sakin, profesyonel, eğitici ve savunmacı olmadan gerçekleri sunuyorsunuz. Bu olgunluk.',
        wrong: 'Bu cevap ya teslimiyetçi ya da savunmacı. Sakin ve bilgilendirici yaklaşım en iyisi.'
      },
      explanation: 'Provokatif sorular stres testidirler. Önemli olan: Sakin kalmak, duygusal tepki vermemek, gerçekleri profesyonelce sunmak.'
    }
  },

  'CM-M5-U5-L4': {
    lesson_id: 'CM-M5-U5-L4',
    title: '⚡ Kişisel Soru Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Zayıf yön sorusunda ne yapılmamalı?', options: ['Farkındalık göstermek', 'Kritik zayıflık söylemek', 'Gelişim planı sunmak', 'Dürüst olmak'], correct: 1 },
        { q: '"5 yıl sonra nerede?" sorusunda ne vurgulanmalı?', options: ['Başka şirkete geçiş', 'Şirkette kalma niyeti', 'CEO olmak', 'Emeklilik'], correct: 1 },
        { q: 'Provokatif sorulara en iyi tepki?', options: ['Kızmak', 'Savunmacı olmak', 'Sakin ve profesyonel kalmak', 'Sessiz kalmak'], correct: 2 },
        { q: 'Güçlü yön nasıl anlatılmalı?', options: ['Genel ifadeler', 'Somut örneklerle', 'Abartarak', 'Kısa ve öz'], correct: 1 },
        { q: 'Zayıflık formülü nedir?', options: ['İnkar', 'Zayıflık + farkındalık + aksiyon', 'Başkalarını suçlama', 'Hiç yok demek'], correct: 1 }
      ]
    }
  },

  // ==================== ÜNİTE 6: TAKIM SORULARI ====================
  'CM-M5-U6-L1': {
    lesson_id: 'CM-M5-U6-L1',
    title: 'Ekip İçi Çatışma',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Ekip Arkadaşlarıyla Anlaşmazlık',
      paragraphs: [
        'Mülakatlarda "zor ekip arkadaşı" senaryoları sıkça sorulur.',
        'Neden sorulur: Kabin ekibi çok yakın çalışır. Çatışma yönetimi kritik.',
        'Yaklaşım 1: Özel konuşma - Sorunu birebir, saygılı şekilde ele alın.',
        'Yaklaşım 2: Ortak zemin bulma - "Biz vs. problem" perspektifi.',
        'Yaklaşım 3: Üst makama başvuru - Son çare, ciddi durumlarda.',
        'ASLA: Arkasından konuşmak, dedikodu yapmak, pasif agresif davranmak.'
      ],
      keyPoints: [
        'Önce özel konuşma dene',
        'Problem odaklı, kişi odaklı değil',
        'Profesyonel ve saygılı kal',
        'Son çare üst makam'
      ]
    }
  },

  'CM-M5-U6-L2': {
    lesson_id: 'CM-M5-U6-L2',
    title: 'Senaryo: Zor Meslektaş',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Kabin ekibindeki bir meslektaşınız sürekli sizin görevlerinizi ihmal ediyor ve siz ek yük taşıyorsunuz.',
      question: 'Bu durumda ne yaparsınız?',
      options: [
        { id: 'A', text: 'Şikayet ederim, Purser\'a söylerim.', isCorrect: false },
        { id: 'B', text: 'Hiçbir şey yapmam, kendi işimi yaparım.', isCorrect: false },
        { id: 'C', text: 'Önce ona özel olarak, saygılı bir dille durumu anlatırım. Birlikte çözüm bulmaya çalışırım. Devam ederse Purser ile konuşurum.', isCorrect: true },
        { id: 'D', text: 'Ben de onun görevlerini ihmal ederim, görsün.', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Kademeli yaklaşım: Önce doğrudan iletişim, sonra üst makam. Bu profesyonel ve olgun.',
        wrong: 'Bu yaklaşım ya hemen şikayetçi ya da pasif ya da intikamcı. Kademeli çözüm en iyisi.'
      },
      explanation: 'Ekip çatışması protokolü: 1) Doğrudan, saygılı iletişim, 2) Ortak çözüm arayışı, 3) Gerekirse üst makam. Bu sırayı takip edin.'
    }
  },

  'CM-M5-U6-L3': {
    lesson_id: 'CM-M5-U6-L3',
    title: '🎮 STAR Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { left: 'S - Situation', right: 'Durumu tanımla' },
        { left: 'T - Task', right: 'Görevini açıkla' },
        { left: 'A - Action', right: 'Ne yaptığını anlat' },
        { left: 'R - Result', right: 'Sonucu paylaş' },
        { left: 'Özel konuşma', right: 'İlk çözüm adımı' },
        { left: 'Üst makam', right: 'Son çare' }
      ]
    }
  },

  // ==================== ÜNİTE 7: FİNAL ====================
  'CM-M5-U7-L1': {
    lesson_id: 'CM-M5-U7-L1',
    title: '🎓 Modül 5 Final Sınavı',
    type: 'exam',
    duration: 15,
    xp: 100,
    exam: {
      questions: [
        { q: '"Neden kabin memuru?" sorusunda ne vurgulanmamalı?', options: ['Güvenlik bilinci', 'Dünyayı gezmek', 'Hizmet tutkusu', 'Kişisel hikaye'], correct: 1 },
        { q: '"Neden bu havayolu?" için en iyi yaklaşım?', options: ['Genel övgü', 'Maaş odaklı', 'Şirkete özel detaylar', 'Arkadaş tavsiyesi'], correct: 2 },
        { q: 'Zor yolcu senaryosunda ilk adım?', options: ['Güvenliği çağırmak', 'Dinlemek ve empati kurmak', 'Görmezden gelmek', 'Tartışmak'], correct: 1 },
        { q: 'Türbülansta ilk yapılacak?', options: ['Kaçmak', 'Ekipmanı sabitlemek', 'Bağırmak', 'Devam etmek'], correct: 1 },
        { q: 'Zayıf yön sorusunda formül?', options: ['İnkar', 'Zayıflık + farkındalık + aksiyon', 'Başkasını suçlama', 'Hiç yok'], correct: 1 },
        { q: '"5 yıl sonra?" sorusunda ne mesaj verilmeli?', options: ['Başka şirkete geçiş', 'Şirkette kalma niyeti', 'Sektör değiştirme', 'Emeklilik'], correct: 1 },
        { q: 'Provokatif sorulara tepki?', options: ['Kızmak', 'Savunmacı olmak', 'Sakin ve profesyonel', 'Ağlamak'], correct: 2 },
        { q: 'Ekip çatışmasında ilk adım?', options: ['Şikayet', 'Özel konuşma', 'Görmezden gelme', 'İntikam'], correct: 1 },
        { q: 'STAR metodunda "A" ne demek?', options: ['Analysis', 'Action', 'Agreement', 'Attitude'], correct: 1 },
        { q: 'Tıbbi acilde koordinasyon kiminle?', options: ['Yolcular', 'Ekip ve kaptan', 'Sadece kendiniz', 'Kimse'], correct: 1 },
        { q: 'Sarhoş yolcu durumunda öncelik?', options: ['Tartışmak', 'Güvenlik değerlendirmesi', 'Daha içki vermek', 'Görmezden gelmek'], correct: 1 },
        { q: 'Güçlü yön nasıl anlatılmalı?', options: ['Genel', 'Somut örnekle', 'Abartarak', 'Kısa'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM5U3to7;
